<app-floating-configurator />
<div class="link-page">
    <div class="link-page-inner">
        <header class="link-page-brand">
            <svg width="132" height="30.7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165 38.343" aria-label="proAV">
                <g transform="translate(-192.662 -398.538)">
                    <g transform="translate(283.839 398.538)">
                        <path d="M305.921,428.649l13.742-23.8c.072-.121.139-.217.195-.294a2.422,2.422,0,0,1,.2.3l13.743,23.8h6.72L325.1,401.935a5.736,5.736,0,0,0-10.475,0L299.2,428.649Z" transform="translate(-299.199 -398.538)" fill="#7ab800" />
                    </g>
                    <g transform="translate(316.34 399.47)">
                        <path d="M371.776,399.628l-13.744,23.8a2.8,2.8,0,0,1-.195.3,2.782,2.782,0,0,1-.2-.3l-13.743-23.8h-6.72L352.6,426.342a5.736,5.736,0,0,0,10.475,0L378.5,399.628Z" transform="translate(-337.176 -399.628)" fill="#7ab800" />
                    </g>
                    <g transform="translate(192.662 398.671)">
                        <path d="M198.483,437.037h-5.821V409.521a9.911,9.911,0,0,1,9.9-9.9h8.053a14.608,14.608,0,0,1,0,29.216h-8.538v-5.826h8.538a8.782,8.782,0,0,0,0-17.564h-8.053a4.081,4.081,0,0,0-4.075,4.078v27.516Z" transform="translate(-192.662 -398.828)" fill="#868686" />
                        <g transform="translate(35.513 0.789)">
                            <path d="M259.588,402.722a14.5,14.5,0,0,0-9-3.1h-6.5a9.909,9.909,0,0,0-9.9,9.9V428.8h5.821V409.515a4.081,4.081,0,0,1,4.076-4.075h6.5a8.714,8.714,0,0,1,5.979,2.363A18.432,18.432,0,0,1,259.588,402.722Z" transform="translate(-234.193 -399.617)" fill="#868686" />
                        </g>
                        <path d="M279.622,429.48c-8.972,0-16.268-6.906-16.268-15.392s7.3-15.393,16.268-15.393,16.27,6.9,16.27,15.393-7.3,15.392-16.27,15.392Zm0-24.965c-5.76,0-10.446,4.294-10.446,9.573s4.686,9.573,10.446,9.573,10.448-4.3,10.448-9.573-4.688-9.573-10.448-9.573Z" transform="translate(-202.906 -398.694)" fill="#868686" />
                    </g>
                </g>
            </svg>
            <span class="link-page-kicker">{{ t()('linkPage.title') }}</span>
        </header>

        <main class="link-page-card">
            @switch (state()) {
                @case ('loading') {
                    <div class="link-page-status">
                        <p-progressspinner [style]="{ width: '2.5rem', height: '2.5rem' }" />
                        <p>{{ t()('linkPage.loading') }}</p>
                    </div>
                }
                @case ('not-found') {
                    <div class="link-page-status">
                        <i class="pi pi-link status-icon"></i>
                        <h1>{{ t()('linkPage.notFound') }}</h1>
                        <p>{{ t()('linkPage.notFoundHint') }}</p>
                    </div>
                }
                @case ('expired') {
                    <div class="link-page-status">
                        <i class="pi pi-clock status-icon"></i>
                        <h1>{{ t()('linkPage.expired') }}</h1>
                        <p>{{ fill('linkPage.expiredHint', { time: formatDate(expiredAtUtc()) }) }}</p>
                    </div>
                }
                @case ('unavailable') {
                    <div class="link-page-status">
                        <i class="pi pi-exclamation-triangle status-icon"></i>
                        <h1>{{ t()('linkPage.unavailable') }}</h1>
                        <p>{{ t()('linkPage.unavailableHint') }}</p>
                        <p-button [label]="t()('linkPage.retry')" icon="pi pi-refresh" (onClick)="load()" />
                    </div>
                }
                @case ('ready') {
                    @if (link(); as link) {
                        <section class="package-summary">
                            <div class="package-title">
                                <h1>{{ link.packageName }}</h1>
                                <div class="package-meta">
                                    <span>{{ link.tenantName }}</span>
                                    <code>{{ link.programNamespace }}</code>
                                </div>
                                @if (link.label) {
                                    <p class="package-label">{{ link.label }}</p>
                                }
                            </div>
                            <div class="version-badges">
                                <p-tag [value]="'v' + link.version.assemblyVersion" severity="success" />
                                <p-tag [value]="t()(link.target === 'latest' ? 'linkPage.latest' : 'linkPage.pinned')" [severity]="link.target === 'latest' ? 'success' : 'info'" [rounded]="true" />
                                <p-tag [value]="t()(link.version.isDebugBuild ? 'linkPage.debug' : 'linkPage.release')" [severity]="link.version.isDebugBuild ? 'warn' : 'secondary'" [rounded]="true" />
                            </div>
                        </section>

                        @if (link.notes) {
                            <section class="link-notes" aria-labelledby="link-notes-title">
                                <h2 id="link-notes-title"><i class="pi pi-info-circle" aria-hidden="true"></i>{{ t()('linkPage.notes') }}</h2>
                                <div class="link-notes-content" [innerHTML]="link.notes | markdown"></div>
                            </section>
                        }

                        <dl class="version-facts">
                            <div>
                                <dt>{{ t()('linkPage.file') }}</dt>
                                <dd>{{ link.version.originalFileName }}</dd>
                            </div>
                            <div>
                                <dt>{{ t()('linkPage.size') }}</dt>
                                <dd>{{ formatSize(link.version.fileSizeBytes) }}</dd>
                            </div>
                            <div>
                                <dt>{{ t()('linkPage.uploaded') }}</dt>
                                <dd>{{ formatDate(link.version.uploadedUtc) }}</dd>
                            </div>
                            @if (link.version.buildTimeUtc) {
                                <div>
                                    <dt>{{ t()('linkPage.built') }}</dt>
                                    <dd>{{ formatDate(link.version.buildTimeUtc) }}</dd>
                                </div>
                            }
                            <div class="wide">
                                <dt>{{ t()('linkPage.sha256') }}</dt>
                                <dd><code>{{ link.version.fileHash }}</code></dd>
                            </div>
                        </dl>

                        @if (link.version.releaseNotes) {
                            <p-accordion class="release-notes-accordion">
                                <p-accordion-panel value="0">
                                    <p-accordion-header>{{ t()('linkPage.releaseNotes') }}</p-accordion-header>
                                    <p-accordion-content>
                                        <div class="release-notes-content" [innerHTML]="link.version.releaseNotes | markdown"></div>
                                    </p-accordion-content>
                                </p-accordion-panel>
                            </p-accordion>
                        }

                        <section class="deadline" [class.deadline-expired]="downloadExpired()">
                            @if (downloadExpired()) {
                                <div class="deadline-text">
                                    <i class="pi pi-clock"></i>
                                    <strong>{{ t()('linkPage.windowExpired') }}</strong>
                                </div>
                            } @else {
                                <div class="deadline-text">
                                    <i class="pi pi-clock"></i>
                                    <span>
                                        {{ t()('linkPage.useBy') }} <strong>{{ formatDate(link.downloadExpiresUtc) }}</strong>
                                        <span class="deadline-remaining">({{ fill('linkPage.remaining', { time: remainingText() }) }})</span>
                                    </span>
                                </div>
                            }
                            <p-button [label]="t()('linkPage.refresh')" icon="pi pi-refresh" [outlined]="!downloadExpired()" size="small" (onClick)="load()" />
                        </section>
                        <p class="hint">{{ fill('linkPage.refreshHint', { minutes: link.downloadWindowMinutes }) }} {{ t()('linkPage.localTime') }}</p>
                        @if (link.linkExpiresUtc) {
                            <p class="hint">{{ fill('linkPage.linkExpires', { time: formatDate(link.linkExpiresUtc) }) }}</p>
                        }

                        <section class="commands">
                            <div class="field slot-field">
                                <label for="linkPageSlot">{{ t()('linkPage.slot') }}</label>
                                <input id="linkPageSlot" type="number" pInputText min="1" max="99" [ngModel]="programSlot()" (ngModelChange)="setSlot($event)" />
                            </div>

                            <div class="field">
                                <label>1. {{ t()('linkPage.step1') }}</label>
                                <div class="console-command-block" [class.command-disabled]="downloadExpired()">
                                    <pre><code>{{ fgetfile() || '…' }}</code></pre>
                                    <p-button icon="pi pi-copy" [text]="true" [rounded]="true" size="small" class="console-command-copy" [disabled]="!fgetfile()" (onClick)="copy(fgetfile())" [pTooltip]="t()('linkPage.copy')" [ariaLabel]="t()('linkPage.copy')" />
                                </div>
                            </div>

                            <div class="field">
                                <label>2. {{ t()('linkPage.step2') }}</label>
                                <div class="console-command-block">
                                    <pre><code>{{ progload() }}</code></pre>
                                    <p-button icon="pi pi-copy" [text]="true" [rounded]="true" size="small" class="console-command-copy" (onClick)="copy(progload())" [pTooltip]="t()('linkPage.copy')" [ariaLabel]="t()('linkPage.copy')" />
                                </div>
                            </div>
                        </section>

                        <section class="instructions">
                            <h2>{{ t()('linkPage.instructions') }}</h2>
                            <ol>
                                <li>{{ t()('linkPage.stepConnect') }}</li>
                                <li>{{ t()('linkPage.stepDownload') }}</li>
                                <li>{{ t()('linkPage.stepLoad') }}</li>
                                <li>{{ t()('linkPage.stepVerify') }}</li>
                            </ol>
                        </section>
                    }
                }
            }
        </main>

        <footer class="link-page-footer">
            <a routerLink="/">{{ t()('linkPage.portal') }}</a>
        </footer>
    </div>
</div>
